/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useEffect } from 'react';
// styles
import injectSheet from 'react-jss';
import styles from './indicator_styles';



/* ========== ~~~~~~~~~~ INDICATOR - CONTENT SCROLLER ~~~~~~~~~~ ========== */
const Indicator = injectSheet(styles)((props) => {
    return (
        <span className={`indicator ${props.classes.indicator}`}>

        </span>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Indicator;
